import {dashboardChartColors} from '../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../common/BarchartColumn';

export const prop = 'status';

export const config = (labels) =>
	barchartColumnConfig({
		id: 'primaryStatus',
		label: labels.status,
		prop,
		getSeries: (item) => [
			{
				name: utilLabels.completeUpperCase,
				data: [item.pTCompl],
				color: dashboardChartColors.blue[3]
			},
			{
				name: utilLabels.inReview,
				data: [item.pTInRev],
				color: dashboardChartColors.blue[2]
			},
			{
				name: utilLabels.inProgress,
				data: [item.pTInProg],
				color: dashboardChartColors.blue[1]
			},
			{
				name: utilLabels.open,
				data: [item.pTOpen],
				color: dashboardChartColors.blue[0]
			}
		]
	});
